import localization from "../../../../config/localization";
import common from "../../../../utils/common";
import { TransactionStatusTypes } from "../../../../models/constants/transactionStatusTypes";
import { formatTimestampToLocalDateTime } from "../../../../utils/dateTimeHelper";
import { BetHistory } from "../../models/response/sportsHistorySummaryResponse";
import { SPORTS_STATUS_STYLE } from "../../models/constants/statusStyles";

export default function ComboBet({ betDetails }: { betDetails: BetHistory }) {
  const firstItem = betDetails.betHistorydetails?.[0];

  return (
    <div className="pb-2">
      <div className="grid gap-y-2 mb-3">
        <div>
          <span>{localization.betid}</span>
          <span className="float-right text-white">
            {betDetails.betslipId}
            <img
              src={"/icons/ic-copy.svg"}
              alt="Copy"
              className="size-4 inline ml-2 cursor-pointer"
              onClick={() =>
                common.copyIdToClipboard(
                  betDetails.betslipId!,
                  localization.betslipid_success_copied,
                )
              }
            />
          </span>
        </div>

        <div>
          <span>{localization.totalodds}</span>
          {betDetails.status?.toLocaleLowerCase() ===
            TransactionStatusTypes.WIN.toLocaleLowerCase() &&
          betDetails.betHistorydetails?.some(
            (x) =>
              x.status?.toLowerCase() ===
                TransactionStatusTypes.HALF_LOST.toLocaleLowerCase() ||
              x.status?.toLowerCase() ===
                TransactionStatusTypes.HALF_WIN.toLocaleLowerCase(),
          ) ? (
            <span className="float-right text-white">
              {localization.partialrefund}
            </span>
          ) : firstItem ? (
            <span className="float-right text-white">
              {firstItem.settleOdds > 0
                ? firstItem.settleOdds.toFixed(2)
                : firstItem.totalOdds.toFixed(2)}
            </span>
          ) : null}
        </div>

        <div>
          <span>{localization.bet}</span>
          <span className="float-right text-white">{`${firstItem?.bet.toFixed(2)}\u20B9`}</span>
        </div>
      </div>

      {betDetails.betHistorydetails &&
        betDetails.betHistorydetails?.length > 0 &&
        betDetails.betHistorydetails.map((item) => {
          return (
            <div className="grid gap-y-2 mt-2 py-2 border-b-[3px] border-dashed border-[#3C3C3C]">
              <div className="grid grid-cols-6">
                <div className="col-span-4 flex items-center">
                  <span className="font-medium text-sm text-white truncate">
                    <img
                      src={
                        item.sportName
                          ? `/icons/sports/sport-name/sport-${item.sportName.toLowerCase().replace(" ", "").replace(":", "-")}.svg`
                          : "/icons/ic-tanis.svg"
                      }
                      alt="Sports Name"
                      className="size-4 invert inline mr-1 relative -top-[2px]"
                      onError={(e) => {
                        const target = e.currentTarget;
                        target.onerror = null;
                        target.src = "/icons/sports-icon-active.svg";
                      }}
                    />
                    {item.competitorName}
                  </span>
                  {item.isLive && (
                    <span>
                      <img
                        src="/icons/ic-live.svg"
                        alt="Live"
                        className="size-7 inline ml-2"
                      />
                    </span>
                  )}
                </div>

                {item.status && (
                  <div className="col-span-2">
                    <span
                      className={`float-right font-medium p-1 text-xs md:text-sm rounded-sm ${
                        SPORTS_STATUS_STYLE[
                          item.status.trim().toLowerCase().replace(" ", "_")
                        ]
                      }`}
                    >
                      {localization.getString(
                        item.status.trim().toLowerCase().replace(" ", "_"),
                      )}
                    </span>
                  </div>
                )}
              </div>

              <div>
                <span className="font-medium text-sm text-white">
                  {item.outComeName}
                </span>
              </div>

              <div>
                <span>{localization.league_name}</span>
                <span className="float-right font-medium text-sm text-white">
                  {item.tournamentName}
                </span>
              </div>

              <div>
                <span>{localization.event_date}</span>
                <span className="float-right font-medium text-sm text-white">
                  {formatTimestampToLocalDateTime(item.scheduled)}
                </span>
              </div>

              <div>
                <span>{localization.odds}</span>
                <span className="float-right font-medium text-sm text-white">
                  {item.odds.toFixed(2)}
                </span>
              </div>
            </div>
          );
        })}
    </div>
  );
}
